import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    const token = localStorage.getItem("ecs_access_token");
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const r = await api.get("/user/me");
      setUser(r.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refreshMe(); }, [refreshMe]);

  const setSession = (data) => {
    localStorage.setItem("ecs_access_token", data.access_token);
    localStorage.setItem("ecs_refresh_token", data.refresh_token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setSession(r.data);
    return r.data.user;
  };
  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    setSession(r.data);
    return r.data.user;
  };
  const logout = () => {
    localStorage.removeItem("ecs_access_token");
    localStorage.removeItem("ecs_refresh_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refreshMe }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
